// extracted by mini-css-extract-plugin
module.exports = {"segment-title":"_9rOXUztJ1XCHVkoAAphqM","segment-title-bordered":"_2XTBMR1ax6kmXn1KE613DI"};